module.exports = __webpack_public_path__ + "media/images/icon-search-on-77b69f2ca551aebe2fe0e4b467f63ef9.svg";